// public/js/modules/modalManager.js

import { getAuth } from "https://www.gstatic.com/firebasejs/9.23.0/firebase-auth.js";
import { saveUserProfile, getUserProfile } from './firestore/firestoreService.js';

const bucketNotificationCache = new Map();


export function showCustomModal(message, options = {}) {
    return new Promise((resolve) => {
        const modalId = 'custom-modal-' + Date.now();
        const {
            type = 'alert',
            confirmText = 'OK',
            cancelText = 'Cancel',
            tertiaryText = 'Cancel',
            placeholder = '',
            initialValue = ''
        } = options;

        let buttonsHtml = '';
        let contentHtml = `<div class="modal-body-content">`; 

        if (type === 'input') {
            contentHtml += `<input type="text" id="modal-input-field" class="form-input" placeholder="${placeholder}" value="${initialValue}">`;
            buttonsHtml = `
                <button class="modal-button modal-cancel-btn">${cancelText}</button>
                <button class="modal-button modal-confirm-btn">${confirmText}</button>
            `;
        } else if (type === 'alert') {
            buttonsHtml = `<button class="modal-button modal-confirm-btn">${confirmText}</button>`;
        } else if (type === 'confirm') {
            buttonsHtml = `
                <button class="modal-button modal-cancel-btn">${cancelText}</button>
                <button class="modal-button modal-confirm-btn">${confirmText}</button>
            `;
        } else if (type === 'prompt') {
             buttonsHtml = `
                <button class="modal-button modal-tertiary-btn">${tertiaryText}</button>
                <button class="modal-button modal-cancel-btn">${cancelText}</button>
                <button class="modal-button modal-confirm-btn">${confirmText}</button>
            `;
        }
        
        contentHtml += `<div class="custom-modal-actions">${buttonsHtml}</div></div>`;

        const modalHtml = `
            <div id="${modalId}" class="custom-modal-overlay">
                <div class="custom-modal-content">
                    <h3 class="modal-title">${message}</h3>
                    ${contentHtml}
                </div>
            </div>
        `;

        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const modalOverlay = document.getElementById(modalId);
        const modalContent = modalOverlay.querySelector('.custom-modal-content');
        const inputField = document.getElementById('modal-input-field');

        if(inputField) inputField.focus();

        requestAnimationFrame(() => {
            modalOverlay.style.opacity = '1';
            modalOverlay.style.pointerEvents = 'auto';
            modalContent.style.transform = 'translate(-50%, -50%) scale(1)';
        });

        const cleanupAndResolve = (result) => {
            modalContent.style.transform = 'translate(-50%, -50%) scale(0.9)';
            modalOverlay.style.opacity = '0';
            setTimeout(() => {
                const inputValue = inputField ? inputField.value.trim() : null;
                modalOverlay.remove();
                
                if (type === 'input') {
                    if (result === 'confirm') {
                        resolve(inputValue);
                    } else {
                        resolve(null); 
                    }
                } else {
                    resolve(result);
                }
            }, 200);
        };

        const confirmBtn = modalOverlay.querySelector('.modal-confirm-btn');
        if (confirmBtn) confirmBtn.addEventListener('click', () => cleanupAndResolve('confirm'));

        const cancelBtn = modalOverlay.querySelector('.modal-cancel-btn');
        if (cancelBtn) cancelBtn.addEventListener('click', () => cleanupAndResolve('cancel'));

        const tertiaryBtn = modalOverlay.querySelector('.modal-tertiary-btn');
        if (tertiaryBtn) tertiaryBtn.addEventListener('click', () => cleanupAndResolve('tertiary'));


        modalOverlay.addEventListener('click', (e) => {
            if (e.target === modalOverlay && type !== 'input') {
                cleanupAndResolve(null);
            }
        });
    });
}



export async function showBucketNotification(songTitle) {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return;

    let show = bucketNotificationCache.get(user.uid);
    if (show === undefined) {
        const profile = await getUserProfile(user.uid);
        show = profile?.showBucketNotification !== false;
        bucketNotificationCache.set(user.uid, show);
    }
    if (!show) return;

    const modalId = 'bucket-notification-modal-' + Date.now();
    const modalHtml = `
        <div id="${modalId}" class="custom-modal-overlay">
            <div class="custom-modal-content">
                <h3 class="modal-title">Song Added to Bucket</h3>
                <div class="modal-body-content">
                    <p>"${songTitle}" added to Bucket. Press 'M' in the ARM menu to manage playlists.</p>
                    <div class="notification-checkbox-wrapper">
                        <input type="checkbox" id="dont-show-again-bucket">
                        <label for="dont-show-again-bucket">Do not show again</label>
                    </div>
                    <div class="custom-modal-actions">
                        <button class="modal-button modal-ok-btn">OK</button>
                    </div>
                </div>
            </div>
        </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHtml);
    const modalOverlay = document.getElementById(modalId);
    const modalContent = modalOverlay.querySelector('.custom-modal-content');
    const checkbox = modalOverlay.querySelector('#dont-show-again-bucket');

    requestAnimationFrame(() => {
        modalOverlay.style.opacity = '1';
        modalOverlay.style.pointerEvents = 'auto';
        modalContent.style.transform = 'translate(-50%, -50%) scale(1)';
    });

    const cleanupAndResolve = () => {
        if (checkbox.checked) {
            console.log("Saving 'Do not show again' preference for bucket notification.");
            bucketNotificationCache.set(user.uid, false);
            saveUserProfile(user.uid, { showBucketNotification: false }).catch(error => {
                console.error("Failed to save notification preference:", error);
            });
        }

        modalContent.style.transform = 'translate(-50%, -50%) scale(0.9)';
        modalOverlay.style.opacity = '0';
        setTimeout(() => {
            modalOverlay.remove();
        }, 200);
    };
    
    const okBtn = modalOverlay.querySelector('.modal-ok-btn');
    if(okBtn) okBtn.addEventListener('click', cleanupAndResolve);

    modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
            cleanupAndResolve();
        }
    });

    return;
}